
(function(){
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  var D=window.NKC||{};
  /* ---------- offer ---------- */
  var offer=$('#nkc-offer'); if(offer){
    var bars=$$('.nkc-bar',offer);
    function rowHTML(pat,idx){
      var o='<div class="nkc-row" data-i="'+idx+'"><div class="nkc-dd"><button type="button" aria-haspopup="listbox"><span class="nkc-sw" style="background-image:url('+D.sw[pat]+')"></span><span class="lb">'+pat+'</span></button><ul role="listbox">';
      D.pats.forEach(function(p){o+='<li data-v="'+p+'"'+(p===pat?' class="on"':'')+'><span class="nkc-sw" style="background-image:url('+D.sw[p]+')"></span><span>'+p+'</span></li>'});
      o+='</ul></div><div class="nkc-sz">';
      D.sizes.forEach(function(s,k){o+='<span data-v="'+s[0]+'"'+(k===1?' class="on"':'')+' title="'+s[0]+'"><i class="nkc-sw" style="background-image:url('+s[1]+')"></i></span>'});
      return o+'</div></div>';
    }
    bars.forEach(function(b){
      var q=+b.dataset.qty,h='';
      for(var i=0;i<q;i++) h+=rowHTML(D.def[i%D.def.length],i);
      $('.rows',b).innerHTML=h;
    });
    function sel(b){bars.forEach(function(x){x.classList.toggle('sel',x===b);x.setAttribute('aria-checked',x===b)});gifts(+b.dataset.qty)}
    bars.forEach(function(b){b.addEventListener('click',function(e){if(e.target.closest('.rows'))return;sel(b)})});
    offer.addEventListener('click',function(e){
      var btn=e.target.closest('.nkc-dd>button');
      $$('.nkc-dd.open',offer).forEach(function(d){if(!btn||d!==btn.parentNode)d.classList.remove('open')});
      if(btn){btn.parentNode.classList.toggle('open');e.stopPropagation();return}
      var li=e.target.closest('.nkc-dd li');
      if(li){var dd=li.closest('.nkc-dd'),v=li.dataset.v;$('.lb',dd).textContent=v;$('button .nkc-sw',dd).style.backgroundImage='url('+D.sw[v]+')';$$('li',dd).forEach(function(x){x.classList.toggle('on',x===li)});dd.classList.remove('open');return}
      var sz=e.target.closest('.nkc-sz span');
      if(sz){$$('span',sz.parentNode).forEach(function(x){x.classList.toggle('on',x===sz)});return}
    });
    document.addEventListener('click',function(e){if(!e.target.closest('.nkc-dd'))$$('.nkc-dd.open').forEach(function(d){d.classList.remove('open')})});
    function gifts(q){
      $$('#nkc-gifts .ib').forEach(function(ib,j){
        var on=((j===0||j===1)&&q>=5)||((j===2||j===3)&&q>=10);
        ib.classList.toggle('un',on);
      });
    }
    var pre=bars.filter(function(b){return b.classList.contains('sel')})[0]||bars[1];
    sel(pre);
    window.NKC_items=function(){
      var b=$('.nkc-bar.sel',offer),m={},miss=[];
      $$('.nkc-row',b).forEach(function(r){
        var p=$('.lb',r).textContent.trim(),s=$('.nkc-sz span.on',r).dataset.v,id=D.vmap[p+'|'+s];
        if(!id){miss.push(p+' / '+s);return}
        m[id]=(m[id]||0)+1;
      });
      return {items:Object.keys(m).map(function(k){return {id:+k,quantity:m[k]}}),miss:miss};
    };
  }
  /* ---------- ATC ---------- */
  var atc=$('#nkc-atc-btn'); if(atc){
    atc.addEventListener('click',function(){
      if(!window.NKC_items) return;
      var r=window.NKC_items(); if(!r.items.length){return}
      var d=document.querySelector('cart-drawer'),sid=d&&d.dataset.sectionId;
      var body={items:r.items}; if(sid){body.sections=[sid];body.sections_url=location.pathname}
      atc.disabled=true;
      fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(res){return res.json()}).then(function(data){
        atc.disabled=false;
        if(data&&data.status){alert(data.description||data.message);return}
        if(d&&d.renderCartContents){try{d.renderCartContents(data)}catch(e){}
          try{document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{data:data,sectionId:sid}}))}catch(e){}
          d.open&&d.open();
        } else location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart';
      }).catch(function(){atc.disabled=false;location.href='/cart'});
    });
  }
  /* ---------- ships-by date ---------- */
  var sd=$('#nkc-ship-date'); if(sd){var t=new Date();t.setDate(t.getDate()+1);
    var s=t.toLocaleDateString('es-MX',{weekday:'short',month:'short',day:'numeric'});sd.textContent=s.replace(/\./g,'')}
  /* ---------- reviews carousel ---------- */
  $$('.nkc-rc').forEach(function(rc){
    var tr=$('.tr',rc),n=$$('.sl',rc).length,i=0,dots=$$('.dots i',rc);
    function go(k){i=(k+n)%n;tr.style.transform='translateX('+(-100*i)+'%)';dots.forEach(function(d,j){d.classList.toggle('on',j===i)})}
    $('.ar.l',rc).addEventListener('click',function(){go(i-1)});$('.ar.r',rc).addEventListener('click',function(){go(i+1)});
    dots.forEach(function(d,j){d.addEventListener('click',function(){go(j)})});
    setInterval(function(){if(!rc.matches(':hover'))go(i+1)},5000);
  });
  /* ---------- videos (muted, no audio track) ---------- */
  var vc=$('#nkc-vcar'); if(vc){
    var trk=$('.tr',vc),fill=$('.sb span',vc);
    $$('.cd',vc).forEach(function(cd){var v=$('video',cd);
      cd.addEventListener('click',function(){
        if(v.paused){$$('.cd',vc).forEach(function(o){if(o!==cd){$('video',o).pause();o.classList.remove('playing')}});v.muted=true;v.play();cd.classList.add('playing')}
        else{v.pause();cd.classList.remove('playing')}
      });
      v.addEventListener('ended',function(){cd.classList.remove('playing')});
    });
    function prog(){var max=trk.scrollWidth-trk.clientWidth;var vis=trk.clientWidth/trk.scrollWidth;fill.style.width=(vis*100)+'%';fill.style.left=(max>0?(trk.scrollLeft/max)*(100-vis*100):0)+'%'}
    trk.addEventListener('scroll',prog);window.addEventListener('resize',prog);prog();
    var down=false,sx=0,sl=0;trk.addEventListener('mousedown',function(e){down=true;sx=e.pageX;sl=trk.scrollLeft});
    window.addEventListener('mouseup',function(){down=false});trk.addEventListener('mousemove',function(e){if(down){trk.scrollLeft=sl-(e.pageX-sx)}});
  }
  /* ---------- desktop: move reviews carousel + note under the gallery ---------- */
  function place(){
    var g=document.querySelector('product-media-gallery');if(!g)return;
    var host=g.parentNode, rc=$('#nkc-rc-wrap'), note=$('#nkc-note-wrap');
    var slot=$('#nkc-under-g');
    if(!slot){slot=document.createElement('div');slot.id='nkc-under-g';slot.className='nkc nkc-under-gallery';g.insertAdjacentElement('afterend',slot)}
    var desk=window.matchMedia('(min-width:768px)').matches;
    if(desk){ if(rc&&rc.parentNode!==slot) slot.appendChild(rc); if(note&&note.parentNode!==slot) slot.appendChild(note);}
    else{ var a=$('#nkc-rc-home'),b=$('#nkc-note-home'); if(rc&&a&&rc.parentNode!==a)a.appendChild(rc); if(note&&b&&note.parentNode!==b)b.appendChild(note);}
  }
  place();window.addEventListener('resize',place);
})();
